import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_NAME, AuthContext, API } from "@/App";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { ExternalLink, Sparkles } from "lucide-react";
import { toast } from "sonner";

const SubscriptionPage = () => {
    const navigate = useNavigate();
    const { shop, token } = useContext(AuthContext);
    const [loading, setLoading] = useState(null);

    // Update page title
    useEffect(() => {
        document.title = `Manage Subscription - ${APP_NAME}`;
    }, []);

    const goToStripePortal = async () => {
        setLoading('loading');
        try {
            const response = await axios.post(
                `${API}/subscription/portal`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Redirect to Stripe
            window.location.href = response.data.url;
        } catch (error) {
            toast.error("Failed to redirect to Stripe. Please try again.");
            setLoading(null);
        }
    };

    return (
        <div className="w-full max-w-3xl">

            <div className="mb-8">
                <h1 className="text-4xl font-bold text-[#f8f8f8] mb-2">Manage Your Subscription</h1>
                <p className="text-lg text-[#f8f8f8]/70">Manage your back office and customer intakes</p>
            </div>

            {/* Intake Link Card */}
            <div className="bg-[#005f6b]/20 backdrop-blur-sm rounded-2xl border border-[#d4af37]/30 p-8 mb-6">
                {
                    shop?.subscription_plan === 'trial' && (
                        <>
                            <h2 className="text-2xl font-semibold text-[#d4af37] mb-4">You are currently on a Trial period ({shop.trial_days_remaining} {shop.trial_days_remaining === 1 ? 'Day' : 'Days'} Left)</h2>
                            <Button
                                onClick={() => navigate("/subscription-required")}
                                className="bg-[#d4af37] hover:bg-[#d4af37]/90 text-[#0a1a1f] font-semibold"
                            >
                                <Sparkles className="w-4 h-4 mr-2" />
                                Upgrade Now
                            </Button>
                        </>
                    )
                }
                {
                    shop?.subscription_plan !== 'trial' && (
                        <>
                            <h2 className="text-2xl font-semibold text-[#d4af37] mb-4">You are currently subscribed to {shop?.subscription_plan} plan</h2>
                            <Button
                                disabled={loading === "loading"}
                                onClick={() => goToStripePortal()}
                                className="bg-[#d4af37] hover:bg-[#d4af37]/90 text-[#0a1a1f] font-semibold"
                            >
                                <ExternalLink className="w-4 h-4 mr-2" />
                                {loading === "loading" ? "Redirecting..." : "Manage Subscription"}
                            </Button>
                            <p className="mt-2 italic text-xs text-[#f8f8f8]/70">* You will be redirected to Stripe to manage your subscription</p>
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default SubscriptionPage;
